module.exports = __webpack_public_path__ + "static/media/0_2019_11_02.6912ac1f.jpg";